import { render, staticRenderFns } from "./website-cms-checker.vue?vue&type=template&id=5870c55e&scoped=true&"
import script from "./website-cms-checker.vue?vue&type=script&lang=js&"
export * from "./website-cms-checker.vue?vue&type=script&lang=js&"
import style0 from "./website-cms-checker.vue?vue&type=style&index=0&id=5870c55e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5870c55e",
  null
  
)

export default component.exports